//#region GERAL

import { CustomClaims } from "./usuarios/UsuarioController"

	export const validacao = {
		requerido: 'Campo obrigatório',
		maxLength: 'Máximo de caracteres: ',
		minLength: 'Mínimo de caracteres: ',
	}

//#endregion

//#region USUÁRIOS

    export const formDefaultData = {
        uid: "",
        displayName: "",
        email: "",
        password: "",
        passwordConfirm: "",
        ehAdministrador: false,
    }

    export interface IUserUpdate
    {
        uid: string
        displayName?: string
        email: string
        password?: string
        passwordConfirm?: string
        ehAdministrador?: boolean
        customClaims?: CustomClaims
    }

//#endregion

export interface IPropsTimecode
{
    versao?: string
    dataHora?: string
    timecode?: string
    resposta?: string
    texto?: string
    autor?: string
    status?: string
}

export enum TipoAnexo 
{
    ANEXO = 'anexo',
    AUTORIZACAO = 'autorizacao',
    PLANILHA_MUSICAL = 'planilha-musical',
    MATERIAL_DIVULGACAO = 'material-divulgacao',
    RECURSO_ACESSIBILIDADE = 'recurso-acessibilidade',
    OUTRO = 'outro'
}

export interface IPropsFieldsAnexo
{
    tipo: TipoAnexo
    title: string
    slug: string
    button_add: string
}

export interface IPropsAnexo
{
    gcs_bucket?: string
    gcs_path?: string
    nome?: string
    link?: string
    tipo?: TipoAnexo
    arquivo?: File
}

export interface IPropsProgramaVideo
{
    idGsatIdFrm?: string
    path?: string
    link?: string
    size?: number    
}

export interface IPropsRepositorio
{
    idRepositorio: number,
    nome: string,
    bucket: string,    
    diretorio: string,    
    idQuemCadastrou: string,
    idQuemAlterou?: string,
    dataCadastro: string,
    dataAlteracao?: string
}

export interface ProgramaModel
{
    idPrograma?: number
    titulo?: string
    idRepositorio: number|string|undefined
    idGsatIdFrm?: string
    anoLicenca?: number
    anoProducao?: string
    anoProducaoInicial?: string
    anoProducaoFinal?: string
    aoVivo?: boolean
    aquisicao?:	boolean
    classificacaoEtaria?: number|string|null
    distribuidor?: string
    duracao?: string
    escaninho?:	string
    baseLimpa?:	boolean
    qtdBlocos?:	string
    numeroEpisodio?: string
    ancineOficioDezembro2013?: boolean
    palavraChave?: string
    possuiAudioME?:	boolean
    possuiClosedCaption?: boolean
    sinopse?: string
    tipoPrograma?: number|string|undefined
    tipoMidia?:	number|string|undefined
    idSerie?: number
    tituloPrograma?: string
    tituloOriginalSerie?: string
    tituloOriginalPrograma?: string
    autor?: string
    consultoriaRoteiro?: string
    apresentador?: string
    consultoria?: string
    direcao?: string
    edicao?: string
    elenco?: string
    entrevistado?: string
    fotografia?: string
    licenciamento?: number|string|null
    listaMusica?: string
    narrador?: string
    producao?: string
    restricoes?: string
    roteiro?: string
    trilhaOriginal?: string
    programaTimecodes?: IPropsTimecode[]|[]
    programaAnexos?: IPropsAnexo[]|[];
    autorizacoes?: IPropsAnexo[]|[];
    planilhasMusicais?: IPropsAnexo[]|[];
    materiaisDivulgacao?: IPropsAnexo[]|[];
    recursosAcessibilidade?: IPropsAnexo[]|[];
    anexosOutros?: IPropsAnexo[]|[];
    programaVideos?: IPropsProgramaVideo[]|[];
    dataExibicao?: string
    dataExibicaoAoVivo?: string
    dataVencimento?: string
    qtdExibicoes?: number
    prazo?: string
    restricaoExibicao?: string
    vigencia?: number|string|undefined
    observacoesGerais?: string
    idiomaVersao?: number|string|undefined
    sinopseIdioma?: string
    versao?: number|string|undefined
    idQuemAlterou?: string
    idQuemCadastrou?: string
    series?: number[]
    linkVideo?: string
    repositorio?: string
    serie?: EntidadesModel

    anexos?: IPropsAnexo[]|[];
}
export interface IFormStatePrograma extends ProgramaModel {};

export const ProgramaDefaultData =
{
    idRepositorio: undefined,
    idGsatIdFrm: "",
    acervoDigital: undefined,
    anoLicenca:  undefined,
    anoProducao: "",
    anoProducaoInicial: "",
    anoProducaoFinal: "",
    aoVivo: false,
    aquisicao: false,
    classificacaoEtaria: "",
    distribuidor:  "",
    duracao: "",
    escaninho: "",
    baseLimpa: false,
    qtdBlocos: "",
    numeroEpisodio: "",
    ancineOficioDezembro2013: false,
    palavraChave: "",
    possuiAudioME:	false,
    possuiClosedCaption: false,
    sinopse: "",
    tipoPrograma: undefined,
    tipoMidia:	undefined,
    idSerie: undefined,
    tituloPrograma: "",
    tituloOriginalSerie: "",
    tituloOriginalPrograma: "",
    autor: "",
    consultoriaRoteiro: "",
    apresentador: "",
    consultoria: "",
    direcao: "",
    edicao: "",
    elenco: "",
    entrevistado: "",
    fotografia: "",
    licenciamento: 0,
    listaMusica: "",
    narrador: "",
    producao: "",
    restricoes: "",
    roteiro: "",
    trilhaOriginal: "",
    timecodes: [],
    anexos: [],
    autorizacoes: [],
    planilhasMusicais: [],
    materiaisDivulgacao: [],
    recursosAcessibilidade: [],
    anexosOutros: [],
    dataExibicao: "",
    dataExibicaoAoVivo: "",
    dataVencimento: "",
    qtdExibicoes: undefined,
    prazo: null,
    restricaoExibicao: "",
    vigencia: undefined,
    observacoesGerais: "",
    idiomaVersao: undefined,
    sinopseIdioma: "",
    versao: undefined,
    linkVideo: "",
    idQuemCadastrou: "",
    idQuemAlterou: "",
    series: [],
} as IFormStatePrograma

export interface IPropsGenero
{
    id: number
    name: string
}
export interface EntidadesModel
{
    titulo?: string
    nome?: string
    bucket?: string
    diretorio?: string
    dataAlerta?: string
    anoProducao?: string
    apresentador?: string
    areaInteresse?: string
    classificacaoEtaria?: number|string|null
    consultoria?: string
    direcao?: string
    edicao?: string
    elenco?: string
    fotografia?: string
    idGenero?: number|null
    produtoras?: number[]
    programas: ProgramaModel[]
    generos?: number[]
    narrador?: string
    numeroCpb?: string
    numeroCrt?: string
    numeroEpisodios?: number|null
    parceiroInstitucional?: string
    parceria?: string
    patrocinador?: string
    pjur?: string
    possuiNumeroCrt?: boolean
    prazoCrtCpb?: string
    producao?: string
    idProdutora?: number|null
    idSerie?: number|null
    roteiro?: string
    sinopseSerie?: string
    sol?: string
    titularidade?: string
    tituloPortugues?: string
    trilhaOriginal?: string
    tipoSerie?: number|string|null
    idQuemCadastrou?: string
    idQuemAlterou?: string
    idRepositorio?: number
    numeroCpbv?: string
    serieAnexos?: IPropsAnexo[]|[]
    autorizacoes?: IPropsAnexo[]|[]
    planilhasMusicais?: IPropsAnexo[]|[]
    materiaisDivulgacao?: IPropsAnexo[]|[]
    recursosAcessibilidade?: IPropsAnexo[]|[]
    anexosOutros?: IPropsAnexo[]|[]

    anexos?: IPropsAnexo[]|[]
}

export const EntidadesDefaultData =
{
    titulo: "",
    nome: "",
    bucket: "",
    diretorio: "",
    dataAlerta: "",
    anoProducao: "",
    anoProducaoInicial: "",
    anoProducaoFinal: "",
    apresentador: "",
    areaInteresse: "",
    classificacaoEtaria: "",
    consultoria: "",
    direcao: "",
    edicao: "",
    elenco: "",
    fotografia: "",
    idGenero: null,
    programas: [],
    generos: [],
    produtoras: [],
    narrador: "",
    numeroCpb: "",
    numeroCrt: "",
    numeroEpisodios: null,
    parceiroInstitucional: "",
    parceria: "",
    patrocinador: "",
    pjur: "",
    possuiNumeroCrt: false,
    prazoCrtCpb: "",
    producao: "",
    idProdutora: null,
    roteiro: "",
    sinopseSerie: "",
    sol: "",
    titularidade: "",
    tituloPortugues: "",
    trilhaOriginal: "",
    tipoSerie: null,
    numeroCpbv: "",
    serieAnexos: [],
    autorizacoes: [],
    planilhasMusicais:[],
    materiaisDivulgacao:[],
    recursosAcessibilidade:[],
    anexosOutros:[],

    anexos:[]
    
}

export interface IFormStateEntidades extends EntidadesModel {}

export enum ETYPEFORM
{
    GERAL       = 'geral',
    USUARIOS    = 'usuarios',
    GENEROS     = 'generos',
    REPOSITORIO = 'repositorio',
    PRODUTORAS  = 'produtoras',
    SERIES      = 'series',
    PROGRAMAS   = 'programas'
}

export enum DataType 
{
	PROGRAMA 	= 'programa',
	ANEXOS		= 'anexos',
    SERIE       = "serie"
}

export const titleFormFields = (name:string,form:ETYPEFORM) =>
{
    switch(name)
    {
        case "titulo":                              return (form == ETYPEFORM.SERIES || form == ETYPEFORM.PROGRAMAS) ? 'Título' : 'Nome'; break;
        case "nome":                                return 'Nome';                          break;
        case "displayName":                         return 'Nome';                          break;
        case "email":                               return 'E-mail';                        break;
        case "password":                            return 'Senha';                         break;
        case "passwordConfirm":                     return 'Confirmar senha';               break;
        case "idRepositorio":                       return 'Repositório';                   break;
        case "idGsatIdFrm":                         return 'ID GSAT/FRM';                   break;
        case "idSerie":                             return 'Série';                         break;
        case "tipoPrograma":                        return 'Tipo de programa';              break;
        case "tituloOriginalSerie":                 return "Título Original da Série";      break;
        case "tituloOriginalPrograma":              return "Título Original do Programa";   break;
        case "tipoMidia":                           return "Tipo de mídia";                 break;
        case "baseLimpa":                           return "Base limpa";                    break;
        case "numeroEpisodio":                      return "Número do episódio";            break;
        case "anoProducao":                         return "Ano da produção";               break;
        case "anoLicenca":                          return "Ano da 1ª licença";             break;
        case "duracao":                             return "Duração";                       break;
        case "qtdBlocos":                           return "Número de blocos";              break;
        case "classificacaoEtaria":                 return "Classificação etária";          break;
        case "possuiAudioME":                       return "Possui áudio M/E";              break;
        case "possuiClosedCaption":                 return "Possui closed caption";         break;
        case "aquisicao":                           return "Aquisição";                     break;
        case "distribuidor":                        return "Distribuidor";                  break;
        case "sinopse":                             return "Sinopse";                       break;
        case "aoVivo":                              return "Ao vivo";                       break;
        case "dataExibicaoAoVivo":                  return "Data de exibição";              break;
        case "ancineOficioDezembro2013":            return "Ancine ofício Dezembro 2013";   break;
        case "palavraChave":                        return "Palavra-chave";                 break;
        case "escaninho":                           return "Escaninho";                     break;
        case "dataExibicao":                        return "Data de exibição";              break;
        case "vigencia":                            return "Vigência";                      break;
        case "qtdExibicoes":                        return "Exibições";                     break;
        case "prazo":                               return "Prazo";                         break;
        case "dataVencimento":                      return "Data do alerta";                break;
        case "restricaoExibicao":                   return "Restrição";                     break;
        case "listaMusica":                         return "Lista de música";               break;
        case "consultoria":                         return "Consultoria";                   break;
        case "licenciamento":                       return "Licenciamento";                 break;
        case "restricoes":                          return "Restrições";                    break;
        case "apresentador":                        return "Apresentador";                  break;
        case "direcao":                             return "Direção";                       break;
        case "edicao":                              return "Edição";                        break;
        case "entrevistado":                        return "Entrevistado";                  break;
        case "elenco":                              return "Elenco";                        break;
        case "fotografia":                          return "Fotografia";                    break;
        case "narrador":                            return "Narrador";                      break;
        case "producao":                            return "Produção";                      break;
        case "roteiro":                             return "Roteiro";                       break;
        case "trilhaOriginal":                      return "Trilha original";               break;
        case "autor":                               return "Autor";                         break;
        case "consultoriaRoteiro":                  return "Consultoria do roteiro";        break;
        case "observacoesGerais":                   return "Observações gerais";            break;    
        case "versao":                              return "Versão";                        break;
        case "idiomaVersao":                        return "Idioma da versão";              break;
        case "sinopseIdioma":                       return "Sinopse em outro idioma";       break;
        case "tipoSerie":                           return "Tipo de série";                 break;
		case "numeroEpisodios":                     return "Episódios";                     break;
		case "generos":                             return "Gêneros";                       break;
		case "produtoras":                          return "Produtoras";                    break;
		case "numeroCpb":                           return "CPB";                           break;
		case "numeroCrt":                           return "CRT";                           break;
		case "prazoCrtCpb":                         return "Prazo CPB/CRT";                 break;
        case "dataAlerta":                          return "Data alerta";                   break;
        case "classificacaoEtaria":                 return "Classificação etária";          break;
		case "titularidade":                        return "Titularidade";                  break;
		case "sinopseSerie":                        return "Sinopse";                       break;
		case "patrocinador":                        return "Patrocinador";                  break;
		case "parceiroInstitucional":               return "Parceiro institucional";        break;
		case "areaInteresse":                       return "Área de interesse";             break;
        case "apresentador":                        return "Apresentador";                  break;
		case "direcao":                             return "Direção";                       break;
		case "elenco":                              return "Elenco";                        break;
		case "roteiro":                             return "Roteiro";                       break;
		case "producao":                            return "Produção";                      break;
		case "fotografia":                          return "Fotografia";                    break;
		case "edicao":                              return "Edição";                        break;
		case "trilhaOriginal":                      return "Trilha original";               break;
		case "parceria":                            return "Parceria";                      break;
		case "consultoria":                         return "Consultoria";                   break;
		case "narrador":                            return "Narrador";                      break;
		case "sol":                                 return "SOL";                           break;
		case "pjur":                                return "PJUR";                          break;
        case "diretorio":                           return "Repositório";                   break;
        case "bucket":                              return "Bucket";                        break;
        case "ehAdministrador":                     return "ehAdministrador";               break;
    }
}

export const bananinhaListError = (objError,form:ETYPEFORM = ETYPEFORM.GERAL) =>
{
    let htmlList:string = '';
    
    for (const chave in objError)
    {
        if (objError.hasOwnProperty(chave))
        {
            const valor = objError[chave];
            const title = titleFormFields(chave,form);

            htmlList += `<li>"<strong>${title}</strong>: ${valor.message}"</li>`;
        }
    }

    return htmlList;
}